<template>
  <div class="batchFee">
    <!-- 费用模块 -->
    <div class="pop_goods">
      <md-popup v-model="show" position="right" @beforeHide="cancelPop">
        <div style="height:0.54rem"></div>
        <div class="pop_goods_box">
          <!-- 头部 -->
          <div class="pop_header">
            <div class="close">
              <md-icon name="wrong" size="sm" @click="cancelPop"></md-icon>
            </div>
            <div>批次费用管理</div>
          </div>
          <!-- 中间 -->
          <div class="pop_section">
            <!-- 产地 -->
            <div class="pop_s_table">
              <div class="title">
                <span>
                  产地费用
                </span>
                <span>
                  <button @click="handleClickAddBatchFee(1)">新增</button>
                </span>
              </div>
              <div class="tip">该批次除货款外，货主垫付的、需与货主进行结算的费用</div>
              <div class="list">
                <table border="0" cellspacing="0" >
                  <tr>
                    <td>费用项目</td>
                    <td>金额</td>
                    <td>操作</td>
                  </tr>
                  <template v-if="list_1 && list_1.length>0">
                    <tr v-for="(item,index) in list_1" :key="index">
                      <td> <div style="width:3rem;padding:0 0.2rem;" class="mand-ellipsis">{{item.name}}</div></td>
                      <td>{{item.price}}</td>
                      <td class="">
                        <md-button type="link" @click="handleClickUpdateBatchFee(item)">修改</md-button>
                        <md-button class="delete" type="link" @click="handleClickDeleteBatchFee(item)">删除</md-button>
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <td colspan="3">暂无</td>
                    </tr>
                  </template>
                  <tr v-if="list_1 && list_1.length>0">
                    <th>合计</th>
                    <th colspan="2">{{total_1}}元</th>
                  </tr>
                </table>
              </div>
            </div>
            <div style="height:0.3rem"></div>
            <!-- 市场 -->
            <div class="pop_s_table">
              <div class="title">
                <span>
                  市场费用
                </span>
                <span>
                  <button @click="handleClickAddBatchFee(2)">新增</button>
                </span>
              </div>
              <div class="tip">该批次除货款、货主垫付的费用外，产生或需分摊的其他费用</div>
              <div class="list">
                <table border="0" cellspacing="0" >
                  <tr>
                    <td>费用项目</td>
                    <td>金额</td>
                    <td>操作</td>
                  </tr>
                  <template v-if="list_2 && list_2.length>0">
                    <tr v-for="(item,index) in list_2" :key="index">
                      <td> <div style="width:3rem;padding:0 0.2rem;" class="mand-ellipsis">{{item.name}}</div></td>
                      <td>{{item.price}}</td>
                      <td class="">
                        <md-button type="link" @click="handleClickUpdateBatchFee(item,index)">修改</md-button>
                        <md-button class="delete" type="link" @click="handleClickDeleteBatchFee(item,index)">删除</md-button>
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <td colspan="3">暂无</td>
                    </tr>
                  </template>
                  <tr v-if="list_2 && list_2.length>0">
                    <th>合计</th>
                    <th colspan="2">{{total_2}}元</th>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </md-popup>
    </div>
    <div class="pop_add">
      <md-popup v-model="show_add" :mask-closable="false">
        <md-popup-title-bar :title="title" :only-close="true" @cancel="cancelAddPop()"></md-popup-title-bar>
        <div class="pop_content">
          <!-- 快捷按钮 -->
          <div class="text_list">
            <div class="title">
              快捷选择
            </div>
            <div class="name_list">
              <div v-for="(item,index) in name_list" :key="index"><div class="mand-ellipsis" v-if="item.type == add_subData.type" @click="handleFastName(item)">{{item.name}}</div></div>
              <!-- <div class="no"> 没有更多了 </div> -->
            </div>
          </div>
          <div class="s_form">
            <div class="input_add_batch">
              <div>费用名称</div>
              <div class="input_add_batch_2">
                <input placeholder="请输入或选择费用名称" type="text" v-model="add_subData.name">
              </div>
            </div>
            <!-- 金额 -->
            <div class="input_add_batch">
              <div>金额</div>
              <div class="input_add_batch_2">
                <input placeholder="请输入金额" type="number" v-model="add_subData.price">
                <span>元</span>
              </div>
            </div>
            <div class="pop_btns">
              <md-button type="warning" plain size="small" inline @click="cancelAddPop()">取消</md-button>
              <md-button type="primary" size="small" inline @click="submitData()">保存</md-button>
            </div>
          </div>
        </div>
      </md-popup>
    </div>
  </div>
</template>
<script>
import { timestampToDate, timestampToTime } from "@/utils/timestamp";
import { batchSurcharge_getList,batchSurcharge_update ,batchSurcharge_delete,costFee_getList} from "@/api/work/stock";
import { isNumFloat,isPosFloat } from "@/utils/validate";
export default {
  name: "batchFee",
  data() {
    return {
      show:false,
      batch_id:"",
      list_1:[],
      list_2:[],
      name_list:[],
      total_1:'',
      total_2:'',


      show_add:false,
      title:'',
      add_subData:{
        batch_id:'',
        batch_surcharge_id:'',
        type:'',
        name:'',
        price:''
      },
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 显示弹窗
    showPop(batch_id){
      this.batch_id = batch_id
      this.add_subData.batch_id = batch_id
      this.show = true
      this.getList()
      this.getCostList()
    },
    // 获取费用列表
    getCostList(){
      costFee_getList({page:1,pageSize:1000}).then(res=>{
        if (res.code == 200) {
          this.name_list = res.data.list
        }
      })
    },
    // 获取列表
    getList(){
      batchSurcharge_getList({batch_id:this.batch_id }).then(res=>{
        if(res.code == 200 ){
          this.total_1 = res.data.type1Total
          this.total_2 = res.data.type2Total
          var list_1 = [],list_2=[]
          for (let i = 0; i < res.data.list.length; i++) {
            const item = res.data.list[i];
            if(item.type == 1){
              list_1.push(item)
            }else{
              list_2.push(item)
            }
          }
          this.list_1 = list_1
          this.list_2 = list_2
        }
      })
    },
    // 取消弹窗
    cancelPop(){
      this.show = false
      this.resetData()
      this.$emit("cancel")
    },
    // 完成弹窗
    finishPop(){
      this.show = false
      this.resetData()
      this.$emit("finish")
    },
    // 重置数据
    resetData(){
      this.add_subData={
        batch_id:'',
        batch_surcharge_id:'',
        type:'',
        name:'',
        price:''
      }
      this.batch_id = ''
      this.list_1=[]
      this.list_2=[]
      this.name_list=[]
    },
    // 删除
    handleClickDeleteBatchFee(item,index){
      this.$dialog.confirm({
        title: '确认',
        content: '是否删除该费用',
        confirmText: '确定',
        onConfirm: () => {
          batchSurcharge_delete({batch_id:this.batch_id,batch_surcharge_id:item.id}).then(res=>{
            if(res.code == 200 ){
              this.$toast.succeed(res.message)
              this.getList()
            }
          })
        },
      })
    },

    // 点击显示新增弹窗
    handleClickAddBatchFee(type){
      this.add_subData.batch_id = this.batch_id
      this.add_subData.batch_surcharge_id = ''
      this.add_subData.type = type
      this.add_subData.name = ""
      this.add_subData.price = ""
      this.title = type == 1?'新增产地费用':'新增市场费用'
      this.show_add = true
    },

    // 显示修改
    handleClickUpdateBatchFee(item){
      this.add_subData.batch_id = this.batch_id
      this.add_subData.batch_surcharge_id = item.id
      this.add_subData.type = item.type
      this.add_subData.name = item.name
      this.add_subData.price = Number(item.price)
      this.title = item.type == 1?'修改产地费用':'修改市场费用'
      this.show_add = true
    },
    
    // 保存
    submitData(){
      if(!this.add_subData.name){this.$toast.info("请输入费用名称！"); return false }
      if(!isPosFloat(this.add_subData.price) || this.add_subData.price == 0){this.$toast.info("请输入费用金额！"); return false }
      batchSurcharge_update(this.add_subData).then(res=>{
        if(res.code == 200){
          this.$toast.succeed(res.message)
          this.finishAddPop()
          this.getList()
          this.getCostList()
        }
      })
    },


    // 点击了快捷选项 
    handleFastName(item){
      this.add_subData.name = item.name
    },

    // 取消添加
    cancelAddPop(){
      this.show_add = false 
      this.add_subData = {
        batch_id:this.batch_id,
        batch_surcharge_id:'',
        type:'',
        name:'',
        price:''
      }
    },
    // 完成添加
    finishAddPop(){
      this.show_add = false 
      this.getList()
      this.add_subData = {
        batch_id:this.batch_id,
        batch_surcharge_id:'',
        type:'',
        name:'',
        price:''
      }
    }
  }
};
</script>
<style lang="less" scoped>
.batchFee {
  // 弹出层
  .pop_goods_box {
    width: 8.8rem;
    height: calc(100% - 0.54rem);
    background-color: #fff;
    .pop_header {
      height: 0.68rem;
      width: 100%;
      text-align: center;
      font-size: 0.28rem;
      line-height: 0.68rem;
      position: relative;
      box-shadow: 0 0.02rem 0.04rem 0.02rem #e1e1e1;
      background-color: #fff;
      .close {
        position: absolute;
        left: 0.2rem;
        top: 0;
      }
    }
    .pop_section {
      width: 100%;
      height: calc(100% - 0.68rem);
      overflow: auto;
      padding: 0.2rem;
      .pop_s_table{
        .title{
          font-size: 0.28rem;
          height: 0.5rem;
          display: flex;
          align-items: center;
          // justify-content: space-between;
          span{
            line-height: 0.4rem;
          }
          button{
            font-size: 0.2rem;
            line-height: 0.4rem;
            border-radius: 0.04rem;
            border: 0.01rem solid #31b158;
            background-color: #fff;
            padding: 0 0.15rem;
            margin-left: 0.3rem;
            &:active{
              color: #fff;
              background-color: #31b158;
            }
          }
        }
        .tip{
          font-size: 0.2rem;
          color: #999;
          margin-bottom: 0.15rem;
        }
        table{
          width: 100%;
          text-align: center;
          font-size: 0.2rem;
          line-height: 0.42rem;
          border:0.01rem solid #e1e1e1;
          outline: none;
          td,th{
            border:0.01rem solid #e1e1e1;
            outline: none;
            width: 33%;
            button{
              font-size: 0.2rem;
              margin: 0 0.1rem;
            }
            .delete{
              color: #ff5257;
            }
          }
        }
      }
    }
  }
  .pop_content{
    width: 6rem;
    padding: 0 0.2rem 0;
    height: 4rem;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    background-color: #fff;
    border-radius: 0 0 0.08rem 0.08rem;
    .text_list{
      width: 2rem;
      .title{
        line-height: 0.5rem;
        font-size: 0.24rem;
        font-weight: bold;
      }
      .name_list{
        width: 100%;
        height: 3.5rem;
        overflow: auto;
        &>div{
          width: 100%;
          &>div{
            line-height: 0.48rem;
            border-bottom: 0.01rem solid #e1e1e1;
            font-size: 0.22rem;
            &:active{
              background-color: #e1e1e1;
            }
          }
        }
      }
      .no{
        width: 100%;
        font-size: 0.2rem;
        line-height: 0.6rem;
        text-align: center;
      }
    }
    .s_form{
      width: 3.3rem;
      // margin-top: 0.4rem;
      .pop_btns{
        padding: 0.4rem 0.3rem 0;
        display: flex;
        justify-content: space-around;
      }
      
      .input_add_batch{
        &>div:nth-child(1){
          line-height: 0.6rem;
        }
        &>.input_add_batch_2{
          line-height: 0.6rem;
          border-bottom: 0.01rem solid #eee;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        input{
          width: 80%;
          // text-indent: 0.15rem;
        }
      }
    }
  }
}
</style>
<style lang="less">
.batchFee{
  .pop_goods{
    .md-popup-mask{
      top: 0.54rem;
      left: 0.7rem;
    }
  }
  .pop_add{

  }
}

</style>